var map = {
	"./ARROW/preview_2.svg": "./src/images/cursors/ARROW/preview_2.svg",
	"./BLURRED/preview_2.svg": "./src/images/cursors/BLURRED/preview_2.svg",
	"./BLURRED/project_hover_2.svg": "./src/images/cursors/BLURRED/project_hover_2.svg",
	"./CIRCLE/preview_2.svg": "./src/images/cursors/CIRCLE/preview_2.svg",
	"./DEFAULT/preview_2.svg": "./src/images/cursors/DEFAULT/preview_2.svg",
	"./EMOJI/preview_2.svg": "./src/images/cursors/EMOJI/preview_2.svg",
	"./FIGMA/preview_2.svg": "./src/images/cursors/FIGMA/preview_2.svg",
	"./LABELED/preview_2.svg": "./src/images/cursors/LABELED/preview_2.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/cursors sync recursive ^\\.\\/.*_2\\.svg$";